export function projectFeatureHover(el, hoverElSelector = '.project-feature__title') {
  const hoverEl = el.querySelector(hoverElSelector);
  const image = el.querySelector('.roll-in-image');

  if (hoverEl && image) {
    hoverEl.addEventListener('mouseenter', function() {
      el.classList.toggle('hover', true);
    });

    hoverEl.addEventListener('mouseleave', function() {
      el.classList.toggle('hover', false);
    });

    image.addEventListener('mouseenter', function() {
      el.classList.toggle('hover', true);
    });

    image.addEventListener('mouseleave', function() {
      el.classList.toggle('hover', false);
    });

    hoverEl.addEventListener('click', function() {
      el.classList.toggle('active');
    });

    image.addEventListener('click', function() {
      el.classList.toggle('active');
    });
  }
}
